import {Digest} from 'quickstart/components/content/Digest'
import {UniversalLink} from 'quickstart/components/content/UniversalLink'
import * as R from 'rambdax'
import type {ComponentProps} from 'react'
import {type MetaObject, deepMerge, logger} from 'tizra'
import {
  type SlotConfig,
  type SlotName,
  type SlotProps,
  defaultSlots,
  useMetadata,
} from '../MetaTile/common'

const log = logger('MetaDigest')

export const metaDigestSlots: {[k in SlotName]?: SlotProps} = {
  title: {force: true},
  snippet: {},
  link: {},
}

type MetaDigestProps = ComponentProps<typeof Digest> & {
  metaObj?: MetaObject
  slots?: {[k in SlotName]?: SlotConfig}
}

const _MetaDigest = ({metaObj, slots: _slots, ...props}: MetaDigestProps) => {
  const slots = R.pick(
    Object.keys(metaDigestSlots),
    deepMerge(defaultSlots)(_slots),
  ) as Exclude<typeof _slots, undefined>

  const {href, title, snippet} = useMetadata({metaObj, slots})

  return (
    <Digest
      as={href ? UniversalLink : undefined}
      {...(href && {href})}
      {...props}
    >
      {title && <Digest.Heading>{title}</Digest.Heading>}
      {snippet && <Digest.Snippet>{snippet}</Digest.Snippet>}
    </Digest>
  )
}

export const MetaDigest = Object.assign(_MetaDigest, {Group: Digest.Group})
